import { render, staticRenderFns } from "./CustomLabel.vue?vue&type=template&id=57bd768c&"
import script from "./CustomLabel.vue?vue&type=script&lang=js&"
export * from "./CustomLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports